<template>
  <div class="blacklistWrap">
    <div class="gnsm">功能说明</div>
    <div class="tips">
      1.黑名单是为了屏蔽部分藏友在同一天内频繁发布相同的帖子，导致大量重复的推送信息，对部分盯盘会员造成困扰；<br />2.通过将上述藏友添加到“黑名单”，添加成功后，将不再收到此藏友的任何发帖体系。
    </div>

    <div class="addBlackUser">
      <van-form ref="vanform" @submit="onSubmit">
        <van-field
          v-model="ruleForm.memberName"
          name="content"
          label="一尘卖家会员（网名全称）"
          placeholder="请输入一尘卖家会员（网名全称）"
          :rules="[{ required: true, message: '请添加完整网名' }]"
        />
        <div class="jgtips">警告：输入的网名必须为一尘网完整网名(不能有错字、漏字、多余空格等)</div>
        <div style="margin: 16px">
          <van-button
            native-type="submit"
            round
            size="small"
            block
            style="background: linear-gradient(0deg, #48C6EF 0%, #6F86D6 100%);border-radius: 5px;color: #fff;font-size: 13px;font-weight: 500;"
            >{{ isEdit ? '确定修改' : '加入黑名单' }}</van-button
          >
        </div>
      </van-form>
    </div>

    <!-- <van-panel v-for="(item, index) in list" style="margin-bottom:20px" :key="index">
      <template #header>
        <van-cell :title="item.memberName" icon="user-o" />
      </template>
      <template #footer>
        <div style="text-align:right">
          <van-button style="margin-right:10px" @click="edit(item)" size="small">编辑</van-button>
          <van-button size="small" @click="del(item, index)" type="danger">删除</van-button>
        </div>
      </template>
    </van-panel> -->

    <div class="sectiondp">
      <template v-if="list.length">
        <div v-for="(item, index) in list" :key="index" class="dRow">
          <div class="l">
            <div class="dRowinfos">
              <div class="title">{{ item.memberName }}</div>
            </div>
          </div>
          <div @click="del(item, index)" class="ricon">
            <img src="../../assets//img/reduceIcon.png" alt="" />
          </div>
        </div>
      </template>
      <div class="nocontent" v-else>
        <img src="../../assets/img/noContentIcon.png" alt="" />
        空空如也，快去添加吧！
      </div>
    </div>

    <rPage></rPage>
  </div>
</template>
<script>
import { getBlackList, addMember, delMember, updateMember } from '@/api/base';
import rPage from '../components/rPage.vue';
export default {
  components: { rPage },
  data() {
    return {
      ruleForm: {
        memberName: '',
        openId: null,
      },
      isEdit: false,
      isEditIndex: 0,
      list: [],
    };
  },
  methods: {
    init() {
      this.ruleForm.openId = window.openId;
      getBlackList({ openId: window.openId }).then(res => {
        let arr = [];
        for (let i = 0; i < res.data.length; i++) {
          arr.push({ memberName: res.data[i], id: i });
        }

        this.list = arr;
        console.log(arr);
      });
    },
    onSubmit() {
      if (this.isEdit) {
        this.updateInfos();
        return;
      }
      addMember(this.ruleForm).then(res => {
        this.$toast('添加成功');
        this.ruleForm.memberName = '';
        this.init();
      });
    },
    edit(item) {
      this.isEdit = true;
      this.isEditIndex = item.id;
      this.ruleForm.memberName = item.memberName;
    },
    updateInfos() {
      updateMember({
        openId: window.openId,
        oldMemberName: this.list[this.isEditIndex].memberName,
        newMemberName: this.ruleForm.memberName,
      }).then(res => {
        this.$toast('更新成功');
        this.ruleForm.memberName = '';
        this.isEdit = false;
        this.isEditIndex = 0;
        this.init();
      });
    },
    del(item, index) {
      delMember({
        memberName: item.memberName,
        openId: window.openId,
      }).then(res => {
        this.list.splice(index, 1);
        this.$toast('删除成功');
      });
    },
  },
  created() {
    this.init();
  },
};
</script>
<style lang="less">
.blacklistWrap {
  padding-bottom: 65px;
  .gnsm {
    height: 36px;
    opacity: 1;
    border-radius: 5px 5px, 0px, 0px;
    background: #ffffff;
    box-shadow: 0px 0px 25.5px #f2f5e9;
    padding-left: 15px;
    font-size: 14px;
    font-weight: 500;
    line-height: 36px;
  }
  .tips {
    padding: 11px 15px 17px 15px;
    font-size: 14px;
    color: #333;
    opacity: 1;
    background: #ffffff;
    box-shadow: 0px 0px 25.5px #f2f5e9;
    font-size: 14px;
    font-weight: 400;
    line-height: 19.21px;
    color: rgba(128, 128, 128, 1);

    span {
      color: red;
    }
  }
  .jgtips {
    font-size: 12px;
    font-weight: 400;
    letter-spacing: 0px;
    line-height: 16.46px;
    color: rgba(255, 87, 51, 1);
    padding: 0 15px;
    margin-top: 5px;
  }
  .addBlackUser {
    margin-top: 20px;
  }

  .sectiondp {
    background: rgba(255, 255, 255, 1);
    // box-shadow: 0px 0px 25.5px rgba(242, 245, 233, 1);
    padding: 0px 25px;
    .dRow {
      display: flex;
      justify-content: space-between;
      border-bottom: 1px solid rgba(246, 247, 240, 1);
      padding-bottom: 8px;
      padding-top: 15px;
      .l {
        display: flex;
        .td {
          display: block;
          width: 18px;
          height: 18px;
          margin-right: 5px;
        }
        .dRowinfos {
          .title {
            font-size: 13px;
            font-weight: 400;
            letter-spacing: 0px;
            line-height: 17.84px;
            color: rgba(68, 71, 54, 1);
            // margin-bottom: 8px;
          }
          .desc {
            font-size: 12px;
            font-weight: 400;
            letter-spacing: 0px;
            line-height: 12.35px;
            color: rgba(166, 166, 166, 1);
          }
        }
      }
      .ricon {
        display: flex;
        align-items: center;
        img {
          display: block;
          width: 18px;
          height: 18px;
        }
      }
    }
    .nocontent {
      display: flex;
      padding-top: 10px;
      font-size: 16px;
      font-weight: 400;
      letter-spacing: 0px;
      line-height: 21.95px;
      color: rgba(166, 166, 166, 1);
      img {
        display: flex;
        width: 64px;
        height: 64px;
        margin-right: 7px;
      }
    }
  }
}
</style>
